import { z } from "zod/v4";

export const AnalyticsEnvObject = {
    sentryDsn: process.env.VITE_SENTRY_DSN,
    amplitudeApiKey: process.env.VITE_AMPLITUDE_API_KEY,
    amplitudeDebugLevel: process.env.VITE_AMPLITUDE_DEBUG_LEVEL,
} as const;

export const AnalyticsConfigSchema = z.object({
    sentryDsn: z.string().optional(),
    amplitudeApiKey: z.string().optional(),
    amplitudeDebugLevel: z.string().optional(),
});

export type TAnalyticsConfig = z.infer<typeof AnalyticsConfigSchema>;
